// package: user
// file: user/service.proto

import * as common_app from "../common/app";
import * as common_method_options from "../common/method_options";
import * as common_service_options from "../common/service_options";
import * as common_version from "../common/version";
import * as user_base_model from "../user/base/model";
import * as user_model from "../user/model";

import { interfaceAPI } from "../sdk/api";
import { createFetcher, CacheMode } from "create-fetcher";
import { defaultCache } from "../sdk/fetcher";

export const SendVerificationSMSRequestV2 = {
    encode(object) {
        const message = {};
        if (object.phone != null) {
            if (object.phone !== "") {
                message.phone = String(object.phone);
            }
        }
        if (object.type != null) {
            if (object.type !== 0) {
                message.type = object.type;
            }
        }
        if (object.app != null) {
            if (object.app !== 0) {
                message.app = object.app;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            phone: "",
            type: 0,
            app: 0,
        };

        if (message.phone != null) {
            object.phone = message.phone;
        }
        if (message.type != null) {
            object.type = message.type;
        }
        if (message.app != null) {
            object.app = message.app;
        }
        return object;
    },
};

export const SendVerificationSMSReply = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const GetMyInfoRequest = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const GetMyInfoV3Request = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const PutMyInfoRequestV2 = {
    encode(object) {
        const message = {};
        if (object.character != null) {
            if (object.character !== 0) {
                message.character = object.character;
            }
        }
        if (object.phone != null) {
            if (object.phone !== "") {
                message.phone = String(object.phone);
            }
        }
        if (object.smsCode != null) {
            if (object.smsCode !== "") {
                message.smsCode = String(object.smsCode);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            character: 0,
            phone: "",
            smsCode: "",
        };

        if (message.character != null) {
            object.character = message.character;
        }
        if (message.phone != null) {
            object.phone = message.phone;
        }
        if (message.smsCode != null) {
            object.smsCode = message.smsCode;
        }
        return object;
    },
};

export const PutMyInfoV3Request = {
    encode(object) {
        const message = {};
        if (object.character != null) {
            if (object.character !== 0) {
                message.character = object.character;
            }
        }
        if (object.phone != null) {
            if (object.phone !== "") {
                message.phone = String(object.phone);
            }
        }
        if (object.smsCode != null) {
            if (object.smsCode !== "") {
                message.smsCode = String(object.smsCode);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            character: 0,
            phone: "",
            smsCode: "",
        };

        if (message.character != null) {
            object.character = message.character;
        }
        if (message.phone != null) {
            object.phone = message.phone;
        }
        if (message.smsCode != null) {
            object.smsCode = message.smsCode;
        }
        return object;
    },
};

export const GetOtherUserInfoRequestV2 = {
    encode(object) {
        const message = {};
        if (object.userID != null) {
            if (object.userID !== "") {
                message.userID = String(object.userID);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            userID: "",
        };

        if (message.userID != null) {
            object.userID = message.userID;
        }
        return object;
    },
};

export const PutDeviceRequestV2 = {
    encode(object) {
        const message = {};
        if (object.platform != null) {
            if (object.platform !== "") {
                message.platform = String(object.platform);
            }
        }
        if (object.deviceID != null) {
            if (object.deviceID !== "") {
                message.deviceID = String(object.deviceID);
            }
        }
        if (object.androidID != null) {
            if (object.androidID !== "") {
                message.androidID = String(object.androidID);
            }
        }
        if (object.tk != null) {
            if (object.tk !== "") {
                message.tk = String(object.tk);
            }
        }
        if (object.channel != null) {
            if (object.channel !== "") {
                message.channel = String(object.channel);
            }
        }
        if (object.oaid != null) {
            if (object.oaid !== "") {
                message.oaid = String(object.oaid);
            }
        }
        if (object.app != null) {
            if (object.app !== 0) {
                message.app = object.app;
            }
        }
        if (object.version != null) {
            message.version = common_version.Version.encode(object.version);
        }
        return message;
    },

    decode(message) {
        const object = {
            platform: "",
            deviceID: "",
            androidID: "",
            tk: "",
            channel: "",
            oaid: "",
            app: 0,
            version: null,
        };

        if (message.platform != null) {
            object.platform = message.platform;
        }
        if (message.deviceID != null) {
            object.deviceID = message.deviceID;
        }
        if (message.androidID != null) {
            object.androidID = message.androidID;
        }
        if (message.tk != null) {
            object.tk = message.tk;
        }
        if (message.channel != null) {
            object.channel = message.channel;
        }
        if (message.oaid != null) {
            object.oaid = message.oaid;
        }
        if (message.app != null) {
            object.app = message.app;
        }
        if (message.version != null) {
            object.version = common_version.Version.decode(message.version);
        }
        return object;
    },
};

export const PutDeviceReply = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const GetMyAttrsRequest = {
    encode(object) {
        const message = {};
        if (object.names != null) {
            if (!Array.isArray(object.names)) {
                throw TypeError("names: array expected");
            }
            if (object.names.length > 0) {
                message.names = [];
                for (let i = 0; i < object.names.length; ++i) {
                    message.names[i] = String(object.names[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            names: [],
        };

        if (message.names != null) {
            object.names = [];
            for (let i = 0; i < message.names.length; ++i) {
                    object.names[i] = message.names[i];
            }
        }
        return object;
    },
};

export const PutMyAttrsReply = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const GetMyAttrsV3Request = {
    encode(object) {
        const message = {};
        if (object.names != null) {
            if (!Array.isArray(object.names)) {
                throw TypeError("names: array expected");
            }
            if (object.names.length > 0) {
                message.names = [];
                for (let i = 0; i < object.names.length; ++i) {
                    message.names[i] = String(object.names[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            names: [],
        };

        if (message.names != null) {
            object.names = [];
            for (let i = 0; i < message.names.length; ++i) {
                    object.names[i] = message.names[i];
            }
        }
        return object;
    },
};

export const GetMyAttrsV3Reply = {
    encode(object) {
        const message = {};
        if (object.names != null) {
            if (!Array.isArray(object.names)) {
                throw TypeError("names: array expected");
            }
            if (object.names.length > 0) {
                message.names = [];
                for (let i = 0; i < object.names.length; ++i) {
                    message.names[i] = String(object.names[i]);
                }
            }
        }
        if (object.attrs != null) {
            message.attrs = user_base_model.UserAttrsV2.encode(object.attrs);
        }
        return message;
    },

    decode(message) {
        const object = {
            names: [],
            attrs: null,
        };

        if (message.names != null) {
            object.names = [];
            for (let i = 0; i < message.names.length; ++i) {
                    object.names[i] = message.names[i];
            }
        }
        if (message.attrs != null) {
            object.attrs = user_base_model.UserAttrsV2.decode(message.attrs);
        }
        return object;
    },
};

export const PutMyAttrsV3Request = {
    encode(object) {
        const message = {};
        if (object.names != null) {
            if (!Array.isArray(object.names)) {
                throw TypeError("names: array expected");
            }
            if (object.names.length > 0) {
                message.names = [];
                for (let i = 0; i < object.names.length; ++i) {
                    message.names[i] = String(object.names[i]);
                }
            }
        }
        if (object.attrs != null) {
            message.attrs = user_base_model.UserAttrsV2.encode(object.attrs);
        }
        return message;
    },

    decode(message) {
        const object = {
            names: [],
            attrs: null,
        };

        if (message.names != null) {
            object.names = [];
            for (let i = 0; i < message.names.length; ++i) {
                    object.names[i] = message.names[i];
            }
        }
        if (message.attrs != null) {
            object.attrs = user_base_model.UserAttrsV2.decode(message.attrs);
        }
        return object;
    },
};

export const PutMyAttrsV3Reply = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const ListPermissionsRequest = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const ListPermissionsReply = {
    encode(object) {
        const message = {};
        if (object.permissions != null) {
            if (!Array.isArray(object.permissions)) {
                throw TypeError("permissions: array expected");
            }
            if (object.permissions.length > 0) {
                message.permissions = [];
                for (let i = 0; i < object.permissions.length; ++i) {
                    message.permissions[i] = object.permissions[i];
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            permissions: [],
        };

        if (message.permissions != null) {
            object.permissions = [];
            for (let i = 0; i < message.permissions.length; ++i) {
                    object.permissions[i] = message.permissions[i];
            }
        }
        return object;
    },
};

export function SendVerificationSMSV2(request, options) {
    return interfaceAPI("/user.Default/SendVerificationSMSV2", SendVerificationSMSRequestV2.encode(request), SendVerificationSMSReply, Object.assign({ isRequestEncrypted: 1, isAuthFree: 1, }, options));
}

export function GetMyInfoV2(request, options) {
    return interfaceAPI("/user.Default/GetMyInfoV2", GetMyInfoRequest.encode(request), user_model.UserInfoV2, options);
}

export function GetMyInfoV3(request, options) {
    return interfaceAPI("/user.Default/GetMyInfoV3", GetMyInfoV3Request.encode(request), user_model.UserInfoV3, Object.assign({ isReplyEncrypted: 1, }, options));
}
export const GetMyInfoV3Fetcher = createFetcher(GetMyInfoV3, { cache: defaultCache, cacheMode: CacheMode.Default, cacheKeyPrefix: "/user.Default/GetMyInfoV3:", cacheMinFresh: 600, cacheMaxAge: 259200 });

export function PutMyInfoV2(request, options) {
    return interfaceAPI("/user.Default/PutMyInfoV2", PutMyInfoRequestV2.encode(request), user_model.UserInfoV2, options);
}

export function PutMyInfoV3(request, options) {
    return interfaceAPI("/user.Default/PutMyInfoV3", PutMyInfoV3Request.encode(request), user_model.UserInfoV3, Object.assign({ isRequestEncrypted: 1, isReplyEncrypted: 1, }, options));
}

export function GetOtherUserInfoV2(request, options) {
    return interfaceAPI("/user.Default/GetOtherUserInfoV2", GetOtherUserInfoRequestV2.encode(request), user_base_model.UserInfoPublicV2, options);
}

export function PutDeviceV2(request, options) {
    return interfaceAPI("/user.Default/PutDeviceV2", PutDeviceRequestV2.encode(request), PutDeviceReply, Object.assign({ isRequestEncrypted: 1, isAuthFree: 1, }, options));
}

export function GetMyAttrsV2(request, options) {
    return interfaceAPI("/user.Default/GetMyAttrsV2", GetMyAttrsRequest.encode(request), user_base_model.UserAttrsV2, options);
}

export function PutMyAttrsV2(request, options) {
    return interfaceAPI("/user.Default/PutMyAttrsV2", user_base_model.UserAttrsV2.encode(request), PutMyAttrsReply, options);
}

export function GetMyAttrsV3(request, options) {
    return interfaceAPI("/user.Default/GetMyAttrsV3", GetMyAttrsV3Request.encode(request), GetMyAttrsV3Reply, options);
}
export const GetMyAttrsV3Fetcher = createFetcher(GetMyAttrsV3, { cache: defaultCache, cacheMode: CacheMode.Default, cacheKeyPrefix: "/user.Default/GetMyAttrsV3:", cacheMinFresh: 900, cacheMaxAge: 259200 });

export function PutMyAttrsV3(request, options) {
    return interfaceAPI("/user.Default/PutMyAttrsV3", PutMyAttrsV3Request.encode(request), PutMyAttrsV3Reply, options);
}

export function ListPermissions(request, options) {
    return interfaceAPI("/user.Default/ListPermissions", ListPermissionsRequest.encode(request), ListPermissionsReply, options);
}


